/* GASSISA
=========================================================================================
* Descripción:
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | listaCortes del cambio
* ---------------------------------------------------------------------------------------
*      1       | 25/04/2025 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 20/08/2026 | Lic. José Luis Aragón Cervantes  | Botón y modal de Vales por cambio en Administración
 *      3       | 27/08/2026 | Lic. José Luis Aragón Cervantes  | Refresco inmediato de corte al registrar retiros de capital
 *      4       | 18/09/2026 | Lic. José Luis Aragón Cervantes  | Herramienta reporte entradas/salidas por periodo
 *      5       | 05/10/2026 | LIC. José Luis Aragón C. (port tenant)         | Paridad original Rev 5: reportes por
 *              |            |                                  | PostFileRequest (ticket consolidado)
 *              |            |                                  | y status de caja desde ApiConfig
 * ---------------------------------------------------------------------------------------
*/

import TextField from "../ui/TextField";
import Autocomplete from "../ui/Autocomplete";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useRequest } from "../../context/System/RequestContext";
import { useAccesos } from "../../context/Catalogos/AccesosContext";
import { useSesion } from "../../context/System/SesionContext";
import { useLayout } from "../../context/System/LayoutContext";
import { Paper, Typography, Box, Stack, Divider, IconButton, Tooltip } from "@mui/material";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import SizeSoftXLayout from "../leyout/SizeSoftXLayout";
import SizeSoftXTableVentas from "../leyout/SizeSoftXTableVentas";
import MnuCortesActions from "./MnuCortesActions";
import MnuGestionCajaActions from "./MnuGestionCajaActions";
import ChartPay from "../utils/ChartPay.jsx";
import ModalVisorCortes from "./ModalVisorCortes";
import ModalCorteCaja from "./ModalCorteCaja";
import ModalAperturaCaja from "./ModalAperturaCaja";
import ModalCierreCaja from "./ModalCierreCaja";
import ModalRetiroCapital from "./ModalRetiroCapital";
import ModalReimpresionCaja from "./ModalReimpresionCaja";
import ModalReporte8020 from "./ModalReporte8020";
import ModalResumenVentasPeriodo from "./ModalResumenVentasPeriodo";
import ModalInventarioExistente from "./ModalInventarioExistente";
import ModalReporteEntradasSalidasPeriodo from "./ModalReporteEntradasSalidasPeriodo";
import FrmLoginValidate from "./FrmLoginValidate";
import SizeSoftXLoadingProcess from "../leyout/SizeSoftXLoadingProcess";
import ModalGenerarValePorCambio from "../ventas/ModalGenerarValePorCambio";

import { useVentas } from "../../context/Ventas/VentasContext";
import { apiReporteCorteGeneralSucursalTicket, apiReporteCorteDetalladoCaja, apiStatusCaja } from "../../settings/ApiConfig";
import { useFormTabLock } from "../../hooks/useFormTabLock";

const dayFilter = (d) => {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
};

const safeNum = (v) => Number(v ?? 0) || 0;

export default function FrmAdministracionCortes() {
  const navigate = useNavigate();
  const { isLocked: isFormLocked } = useFormTabLock('administracion_cortes', {
    title: 'Administración Cortes',
    onLockDetected: (info) => {
      handleOpenAlert(`El formulario de ${info?.title || 'Administración Cortes'} ya está abierto en otra pestaña` , "error");
    }
  });

  const [folioCorte, setFolioCorte] = useState(0);
  const { GetRequest, PostFileRequest } = useRequest();
  const [openModalAperturaCaja, setOpenModalAperturaCaja] = useState(false);
  const [openModalCierreCaja, setOpenModalCierreCaja] = useState(false);
  const [openModalRetiroCapital, setOpenModalRetiroCapital] = useState(false);
  const [statusCajaAdmin, setStatusCajaAdmin] = useState(null);
  const [openModalReimpresion, setOpenModalReimpresion] = useState(false);
  const [tipoReimpresion, setTipoReimpresion] = useState('apertura');
  const [openModalReporte8020, setOpenModalReporte8020] = useState(false);
  const [openModalResumenVentasPeriodo, setOpenModalResumenVentasPeriodo] = useState(false);
  const [openModalInventarioExistente, setOpenModalInventarioExistente] = useState(false);
  const [openModalEntradasSalidasPeriodo, setOpenModalEntradasSalidasPeriodo] = useState(false);
  const [openModalValePorCambio, setOpenModalValePorCambio] = useState(false);
  const [openModalLoginValePorCambio, setOpenModalLoginValePorCambio] = useState(false);
  const [usuarioAutorizaVale, setUsuarioAutorizaVale] = useState("");

  const [fechaFilter, setFechaFilter] = useState(dayFilter(new Date()));
  const [listaVendedores, setListaVendedores] = useState([]);
  const [vendedor, setVendedor] = useState("");
  const [cajaSeleccionada, setCajaSeleccionada] = useState(null);

  const { HandleCargarUsuarios, usuarios } = useAccesos();
  const { parametrosCajaForm, usuarioData } = useSesion();
  const { handleOpenAlert } = useLayout();

  const {
    listaCortes = [],
    listaCajas = [],
    handleOntenerListaCajasRegistro,
    corteSeleccionado,
    setCorteSeleccionado,

    handleCloseModalLoginValidatorCortes,
    handleAplicacionCortes,
    openModalValidator,

    openModalCortes,
    openModalVisorCortes,
    handleCerrarModalCortes,
    handleAplicarCorte,
    handleCerrarModalVisorCortes,

    handleHabilitarHerramientas,
    handleCloseModalLoginValidarAcceso,
    openModalValidarAcceso,
    statusHerramientasAdministrativas,

    listaVentas,
    setListaVentas,
    statusWaiting,
    setStatusWaiting,
    handleObtenerVentaDelDiaCajaFecha,
  } = useVentas();

  const handleChangeFolioCorte = (valor) => {
    setFolioCorte(valor);
  };

  const [ventaSeleccionada, setVentaSeleccionada] = useState([]);
  const [dataChart, setDataChart] = useState([
    { value: "", label: "" },
  ]);

  const opcionesCajas = useMemo(() => {
    return listaCajas ?? [];
  }, [listaCajas]);

  const etiquetaCaja = (opt) => {
    if (!opt) return "";
    const pc = String(opt ?? "").trim();
    const ven = String(opt.vendedor ?? "").trim();
    return ven ? `Caja ${pc} - ${ven}` : `Caja ${pc}`;
  };

  const etiquetaVendedor = (opt) => {
    if (!opt) return "";
    return String(opt.nombrevendedor ?? opt.nombre ?? opt.usuario ?? "").trim();
  };

  const limpiarSeleccion = () => {
    setVendedor("");
    setCajaSeleccionada(null);
    setCorteSeleccionado(null);
    setVentaSeleccionada([]);
    setListaVentas([]);
    setDataChart([{ value: "", label: "" }]);
  };

const cargarGraficaDesdeResumen = (c) => {
      const importe = (value) => Number(value) || 0;
      setDataChart([
        { label: "Efectivo ventas", value: importe(c?.totalefectivo) },
        { label: "Efectivo crédito clientes", value: importe(c?.totalefectivocredito) },
        { label: "Efectivo abonos apartados", value: importe(c?.totalabonosapartados) },
        { label: "Tarjetas D-C", value: importe(c?.totaltarjetadebito) + importe(c?.totaltarjetacredito) },
        { label: "Transferencia", value: importe(c?.totaltransferencia) },
        { label: "Saldo crédito clientes", value: importe(c?.totalcreditocliente) },
        { label: "Devoluciones", value: importe(c?.totaldevoluciones) },
      ]);
    };

  const ventasConIdUnico = useMemo(() => {
    const ventas = Array.isArray(listaVentas) ? listaVentas : [];
    const sorted = [...ventas].sort((a, b) => {
      const rem = String(a.remision ?? "").localeCompare(String(b.remision ?? ""));
      if (rem !== 0) return rem;
      return String(a.pc ?? "").localeCompare(String(b.pc ?? ""));
    });

    return sorted.map((v, idx) => ({
      ...v,
      id: `${v.remision ?? "R"}-${String(v.pc ?? "").trim()}-${idx}`,
      vendedorpreventa: String(v.vendedorpreventa ?? "").trim(),
    }));
  }, [listaVentas]);

  const detallesFiltrados = useMemo(() => {
    const pcSel = String(cajaSeleccionada?.pc ?? cajaSeleccionada ?? "").trim();
    const vendedorSel = String(vendedor?.usuario ?? vendedor ?? "").trim();
    if (!pcSel) return [];

    return (ventasConIdUnico ?? []).filter((v) =>
      String(v.pc ?? "").trim() === pcSel &&
      (!vendedorSel || String(v.usuario ?? "").trim() === vendedorSel)
    );
  }, [ventasConIdUnico, cajaSeleccionada, vendedor]);

  const cab = useMemo(
    () => (Array.isArray(listaCortes) && listaCortes.length > 0 ? listaCortes[0] : null),
    [listaCortes]
  );

  useEffect(() => {
    if (!statusHerramientasAdministrativas) {
      limpiarSeleccion();
      setFechaFilter(dayFilter(new Date()));
    }
  }, [statusHerramientasAdministrativas]);

  useEffect(() => {
    if (isFormLocked) {
      alert("El formulario de Administración Cortes ya está abierto en otra pestaña del navegador.\n\nPor favor, cierre la otra ventana o pestaña para continuar.");
      setTimeout(() => {
        navigate("/*");
      }, 900);
    }
  }, [isFormLocked]);

  const handleSelectCaja = async (val) => {
    setCajaSeleccionada(val ?? null);
    setCorteSeleccionado(null);
    setVentaSeleccionada([]);

    if (!val) {
      setListaVentas([]);
      setStatusCajaAdmin(null);
      return;
    }

    const cajaValue = getCajaValue(val);
    await handleObtenerVentaDelDiaCajaFecha(cajaValue, fechaFilter, vendedor);
    if (cajaValue) {
      try {
        const url = apiStatusCaja.replace("{caja}", cajaValue);
        const response = await GetRequest({ url });
        if (!response.hasError && response.result) {
          setStatusCajaAdmin(response.result);
        }
      } catch (error) {
        handleOpenAlert("Error al consultar status de caja: " + error, "error");
      }
    }
  };

  useEffect(() => {
    if (!listaCortes) {
      setDataChart([{ value: "", label: "" }]);
      return;
    }

    const c = listaCortes[0] ?? {};
    cargarGraficaDesdeResumen(c);
  }, [listaCortes, cajaSeleccionada, fechaFilter, vendedor]);

  const listaVendedoresOrdenada = listaVendedores?.slice().sort((c, d) => c.usuario.localeCompare(d.usuario));
  let listaVendedoresAutoComplete = [];
  listaVendedoresOrdenada.map((y) =>
    listaVendedoresAutoComplete.push({
      id: y.id,
      usuario: y.usuario,
    })
  );

  const handleChangeVendedor = async (e) => {
    const valor = String(e?.usuario ?? "").trim();
    setVendedor(valor);
    const cajaValue = getCajaValue(cajaSeleccionada);
    await handleObtenerVentaDelDiaCajaFecha(cajaValue, fechaFilter, valor);
  };

  useEffect(() => {
    if (listaCajas.length === 0) {
      handleOntenerListaCajasRegistro();
    }
    HandleCargarUsuarios();
  }, []);

  useEffect(() => {
    setListaVendedores(usuarios ?? []);
  }, [usuarios]);

  const handleChangeDateFilter = async (d) => {
    setFechaFilter(dayFilter(d));
    const cajaValue = getCajaValue(cajaSeleccionada);
    await handleObtenerVentaDelDiaCajaFecha(cajaValue, dayFilter(d), vendedor);
  };

  const handleGenerarCorteCaja = () => { };

  const handleRefrescarDatos = async () => {
    if (!cajaSeleccionada) {
      handleOpenAlert("Seleccione una caja para refrescar los datos", "warning");
      return;
    }
    const cajaValue = getCajaValue(cajaSeleccionada);
    await handleObtenerVentaDelDiaCajaFecha(cajaValue, fechaFilter, vendedor);
    await refreshStatusCaja();
  };

  const refreshStatusCaja = async () => {
    const cajaValue = getCajaValue(cajaSeleccionada);
    if (!cajaValue) {
      return;
    }

    try {
      const url = apiStatusCaja.replace("{caja}", cajaValue);
      const response = await GetRequest({ url });

      if (!response.hasError && response.result) {
        setStatusCajaAdmin(response.result);
      }
    } catch (error) {
      handleOpenAlert("Error al refrescar status de caja:" + error, "error");
    }
  };

  const getCajaValue = (caja) => {
    if (!caja) return null;
    const pc = caja.pc ?? caja.PC ?? caja.value ?? caja.label ?? null;
    if (pc === null) {
      const strCaja = String(caja);
      return strCaja && strCaja !== "" && strCaja !== "[object Object]" ? strCaja : null;
    }
    return String(pc).trim() || null;
  };

  const handleAbrirAperturaCaja = (status) => {
    const cajaValue = getCajaValue(cajaSeleccionada);
    if (!cajaValue) {
      handleOpenAlert("Seleccione una caja del listado", "warning");
      return;
    }
    setStatusCajaAdmin(status);
    setOpenModalAperturaCaja(true);
  };

  const handleAbrirCierreCaja = (status) => {
    const cajaValue = getCajaValue(cajaSeleccionada);
    if (!cajaValue) {
      handleOpenAlert("Seleccione una caja del listado", "warning");
      return;
    }
    setStatusCajaAdmin(status);
    setOpenModalCierreCaja(true);
  };

  const handleAbrirRetiroCapital = (status) => {
    const cajaValue = getCajaValue(cajaSeleccionada);
    if (!cajaValue) {
      handleOpenAlert("Seleccione una caja del listado", "warning");
      return;
    }
    setStatusCajaAdmin(status);
    setOpenModalRetiroCapital(true);
  };

  const handleAbrirReimpresion = (tipo) => {
    const cajaValue = getCajaValue(cajaSeleccionada);
    if (!cajaValue) {
      handleOpenAlert("Seleccione una caja del listado", "warning");
      return;
    }
    setTipoReimpresion(tipo);
    setOpenModalReimpresion(true);
  };

  const handleAbrirReporte8020 = () => {
    setOpenModalReporte8020(true);
  };

  const handleAbrirResumenVentasPeriodo = () => {
    setOpenModalResumenVentasPeriodo(true);
  };

  const handleAbrirInventarioExistente = () => {
    setOpenModalInventarioExistente(true);
  };

  const handleAbrirEntradasSalidasPeriodo = () => {
    setOpenModalEntradasSalidasPeriodo(true);
  };

  const handleAbrirValePorCambio = async () => {
    const cajaValue = getCajaValue(cajaSeleccionada);
    if (!cajaValue) {
      handleOpenAlert("Seleccione una caja del listado", "warning");
      return;
    }

    try {
      const url = apiStatusCaja.replace("{caja}", cajaValue);
      const response = await GetRequest({ url });

      if (response.hasError || !response.result?.abierta) {
        handleOpenAlert("No se pueden generar vales por cambio mientras la caja esté cerrada", "warning");
        return;
      }
      setStatusCajaAdmin(response.result);
    } catch (error) {
      handleOpenAlert("Error al consultar el status de la caja: " + error.message, "error");
      return;
    }

    setOpenModalLoginValePorCambio(true);
  };

  const handleConfirmLoginValePorCambio = async (success, usuarioAutorizado) => {
    setOpenModalLoginValePorCambio(false);
    if (!success) return;
    setUsuarioAutorizaVale(usuarioAutorizado?.usuario || usuarioAutorizado?.Usuario || usuarioData?.Usuario || "");
    setOpenModalValePorCambio(true);
  };

  const handleGenerarReporteCorteGeneralSucursal = async () => {
    setStatusWaiting(true);

    try {
      const fechaLocal = new Date(fechaFilter.getFullYear(), fechaFilter.getMonth(), fechaFilter.getDate());
      const year = fechaLocal.getFullYear();
      const month = String(fechaLocal.getMonth() + 1).padStart(2, '0');
      const day = String(fechaLocal.getDate()).padStart(2, '0');
      const fechaFormateada = `${year}-${month}-${day}`;
      const data = {
        fecha: fechaFormateada,
        sucursal: parametrosCajaForm?.sucursal ?? '',
        usuario: usuarioData?.Usuario ?? '',
        tipousuario: "ADMINISTRADOR",
      };

      const result = await PostFileRequest({
        url: apiReporteCorteGeneralSucursalTicket,
        body: data,
        filename: `CorteGeneralSucursal-${fechaFormateada}.pdf`,
        openInNewTab: true,
        loader: "Cargando reporte...",
      });

      if (!result) throw new Error("No se pudo generar el reporte");
    } catch (error) {
      handleOpenAlert("Error al generar reporte: " + error.message, "error");
    } finally {
      setStatusWaiting(false);
    }
  };

  const handleGenerarReporteCorteDetalladoCaja = async () => {
    setStatusWaiting(true);

    try {
      if (!cajaSeleccionada) {
         handleOpenAlert("Debe seleccionar una caja para poder generar el reporte detallado.", "warning");
         setStatusWaiting(false);
         return;
      }

      const data = {
        ventas: listaVentas ?? [],
        cabecero: cab ?? {},
        usuario: usuarioData?.Usuario ?? '',
        caja: cajaSeleccionada?.pc ?? cajaSeleccionada ?? ''
      };

      const result = await PostFileRequest({
        url: apiReporteCorteDetalladoCaja,
        body: data,
        filename: `ReporteCorteDetallado.pdf`,
        openInNewTab: true,
        loader: "Cargando reporte detallado...",
      });

      if (!result) throw new Error("No se pudo generar el reporte detallado");
    } catch (error) {
      handleOpenAlert("Error al generar reporte detallado: " + error.message, "error");
    } finally {
      setStatusWaiting(false);
    }
  };

  const handleCierreExitosoApertura = async () => {
    await refreshStatusCaja();
  };

  const handleCierreExitosoCaja = async () => {
    await refreshStatusCaja();
    await handleOntenerListaCajasRegistro();
    const cajaValue = getCajaValue(cajaSeleccionada);
    if (cajaValue) {
      await handleObtenerVentaDelDiaCajaFecha(cajaValue, fechaFilter, vendedor);
    }
  };

  const handleCierreExitosoRetiro = async () => {
    await refreshStatusCaja();
    const cajaValue = getCajaValue(cajaSeleccionada);
    if (cajaValue) {
      await handleObtenerVentaDelDiaCajaFecha(cajaValue, fechaFilter, vendedor);
    }
  };

  useEffect(() => { }, [statusHerramientasAdministrativas]);

  return (
    <Fragment>
      <div className="mainAdministracion">
        <SizeSoftXLayout
          titlePage="Módulo de administración"
          buttonActions={
            <Fragment>
              <MnuCortesActions
                onGenerarReporteCorteGeneral={handleGenerarReporteCorteGeneralSucursal}
                onGenerarReporte8020={handleAbrirReporte8020}
                onAbrirResumenVentasPeriodo={handleAbrirResumenVentasPeriodo}
                onAbrirInventarioExistente={handleAbrirInventarioExistente}
                onAbrirEntradasSalidasPeriodo={handleAbrirEntradasSalidasPeriodo}
                onRefrescar={handleRefrescarDatos}
              />
              <MnuGestionCajaActions
                onAbrirAperturaCaja={handleAbrirAperturaCaja}
                onAbrirCierreCaja={handleAbrirCierreCaja}
                onAbrirRetiroCapital={handleAbrirRetiroCapital}
                onAbrirReimpresion={handleAbrirReimpresion}
                statusCaja={statusCajaAdmin}
                cajaSeleccionada={cajaSeleccionada}
                statusHerramientasAdministrativas={statusHerramientasAdministrativas}
                listaCortes={listaCortes}
                onGenerarReporteCorteDetallado={handleGenerarReporteCorteDetalladoCaja}
              />
              <Tooltip title="Generar vale por cambio">
                <span>
                  <IconButton onClick={handleAbrirValePorCambio} disabled={!statusCajaAdmin?.abierta}>
                    <ReceiptLongIcon className="icon" /><p className="icon">Vale</p>
                  </IconButton>
                </span>
              </Tooltip>
            </Fragment>
          }
        >
          {/* CONTROL FILTER */}
          <Paper elevation={2} sx={{ p: 1.5, mb: 2 }}>
            <Typography sx={{ fontWeight: 700, mb: 1 }}>
              Filtro de control
            </Typography>

            <Stack
              spacing={2}
              direction="row"
              flexWrap="wrap"
              alignItems="center"
            >
              <DatePicker
                selected={fechaFilter}
                onChange={(d) => handleChangeDateFilter(d)}
                dateFormat="dd/MM/yyyy"
                className="custom-datepicker"
                disabled={!statusHerramientasAdministrativas}
              />
            </Stack>

            <Divider sx={{ my: 1.5 }} />

            <Stack
              spacing={2}
              direction="row"
              flexWrap="wrap"
              alignItems="center"
            >
              <TextField autoComplete="off"
                label="Folio corte"
                value={folioCorte ?? 0}
                sx={{ width: 160 }}
                disabled
              />

              <Autocomplete
                disabled={!statusHerramientasAdministrativas}
                options={opcionesCajas}
                value={cajaSeleccionada}
                onChange={(e, val) => handleSelectCaja(val)}
                isOptionEqualToValue={(opt, val) => {
                  if (!opt || !val) return false;
                  const optPc = String(opt.pc ?? opt.PC ?? opt.value ?? opt.label ?? "").trim();
                  const valPc = String(val.pc ?? val.PC ?? val.value ?? val.label ?? "").trim();
                  return optPc === valPc;
                }}
                getOptionLabel={etiquetaCaja}
                renderInput={(params) => (
                  <TextField autoComplete="off"
                    {...params}
                    label="Caja (selección única)"
                    sx={{ width: 420 }}
                  />
                )}
              />

              <Autocomplete
                disabled={!statusHerramientasAdministrativas}
                options={listaVendedoresOrdenada}
                value={listaVendedoresOrdenada.find(v => String(v?.usuario ?? v?.id ?? "") === String(vendedor)) ?? null}
                onChange={(event, newValue) => { handleChangeVendedor(newValue); }}
                clearOnBlur={false}
                isOptionEqualToValue={(opt, val) =>
                  String(opt?.usuario ?? opt?.id ?? "").trim() === String(val?.usuario ?? val?.id ?? "").trim()
                }
                getOptionLabel={(opt) =>
                  String(opt?.nombrevendedor ?? opt?.nombre ?? opt?.usuario ?? "").trim()
                }
                renderInput={(params) => (
                  <TextField autoComplete="off"
                    {...params}
                    label="Vendedor"
                    sx={{ width: 420 }}
                  />
                )}
              />

            </Stack>

            {/* Trigger “a la vieja escuela”: cambia fecha/usuario => recarga lista cajas */}
            <Box sx={{ mt: 1.5 }}>
              <Typography
                variant="caption"
                sx={{ opacity: 0.75, display: "block" }}
              >
                Tip: si cambias fecha/vendedor, vuelve a cargar un corte de ventas
                refrescar ventas.
              </Typography>
            </Box>
          </Paper>

          {/* BODY */}
          <Box className="main-administracion-body-header-adminform">
            <Box className="body-tablas-main" sx={{ display: "flex", gap: 2 }}>
              <Box className="tabla-ventas" sx={{ flex: 1, minWidth: 0 }}>
                <SizeSoftXTableVentas
                  columns={[
                    { title: "Tipo pago", field: "tipopago" },
                    { title: "Remisión", field: "remision" },
                    { title: "Caja", field: "pc" },
                    { title: "Vendedor", field: "usuario", width: 200 },
                    { title: "VEND. PREVE", field: "vendedorpreventa", width: 300 },
                    { title: "Descripción", field: "descripcion" },
                    { title: "Medida", field: "medida" },
                    { title: "Cantidad", field: "cantidadarticulo" },
                    { title: "Costo cliente", field: "costocliente" },
                    { title: "Descuento", field: "descuentoarticulo" },
                    { title: "Subtotal", field: "subtotalarticulo" },
                    { title: "IVA artículo", field: "ivaarticulo" },
                    { title: "Total", field: "totalarticulo" },
                    { title: "Total tipo pago", field: "totaltipopago" },
                    { title: "Efectivo recibido", field: "totalefectivo" },
                  ]}
                  id={"id"}
                  data={detallesFiltrados}
                  row={ventaSeleccionada}
                  setRow={setVentaSeleccionada}
                  fontSize="small"
                  rowsPerPageIntro={50}
                />
              </Box>

              <Box className="chart-container">
                <ChartPay data={dataChart} />
              </Box>
            </Box>

{/* TOTALES ABAJO */}
            <Box sx={{ mt: 2 }}>
              <Paper elevation={2} sx={{ p: 1.5 }}>
                <Typography sx={{ mb: 1, fontWeight: 700 }}>
                  Totales del corte
                </Typography>

                {!cab?.pc ? (
                  <Typography variant="body2">
                    Selecciona una caja para ver totales.
                  </Typography>
                ) : (
                  <>
                    {/* SECCIÓN: TOTALES EN CAJA */}
                    <Typography variant="subtitle2" sx={{ mb: 1, color: 'primary.main', fontWeight: 600 }}>
                      Totales en caja
                    </Typography>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                      <TextField autoComplete="off" label="Total efectivo" value={cab.totalefectivo ?? 0} sx={{ width: 200 }} InputProps={{ readOnly: true }} />
                      <TextField autoComplete="off" label="Efectivo crédito clientes" value={cab.totalefectivocredito ?? 0} sx={{ width: 200 }} InputProps={{ readOnly: true }} />
                      <TextField autoComplete="off" label="Tarjeta débito" value={cab.totaltarjetadebito ?? 0} sx={{ width: 200 }} InputProps={{ readOnly: true }} />
                      <TextField autoComplete="off" label="Tarjeta crédito" value={cab.totaltarjetacredito ?? 0} sx={{ width: 200 }} InputProps={{ readOnly: true }} />
                      <TextField autoComplete="off" label="Transferencia" value={cab.totaltransferencia ?? 0} sx={{ width: 200 }} InputProps={{ readOnly: true }} />
                      <TextField autoComplete="off" label="Efectivo abonos apartados" value={cab.totalabonosapartados ?? 0} sx={{ width: 200 }} InputProps={{ readOnly: true }} />
                      <TextField autoComplete="off" label="Abonos préstamos" value={cab.totalabonosprestamos ?? 0} sx={{ width: 200 }} InputProps={{ readOnly: true }} />
                      <TextField autoComplete="off" label="Devoluciones (-)" value={cab.totaldevoluciones ?? 0} sx={{ width: 200 }} InputProps={{ readOnly: true, color: 'error' }} />
                      <TextField autoComplete="off" label="Vales por cambio generados" value={cab.totalvalesporcambiogenerados ?? 0} sx={{ width: 200 }} InputProps={{ readOnly: true }} />
                    </Box>

                    {/* TOTAL GENERAL */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2, p: 1.5, borderRadius: 1 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        TOTAL GENERAL:
                      </Typography>
                      <TextField autoComplete="off" 
                        label="Total" 
                        value={cab.totalgeneral ?? 0} 
                        sx={{ width: 200 }} 
                        InputProps={{ readOnly: true }} 
                      />
                    </Box>

                    {/* SECCIÓN: OTROS CONCEPTOS (informativo) */}
                    <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary', fontWeight: 600 }}>
                      Otros conceptos
                    </Typography>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      <TextField autoComplete="off" label="Saldo crédito clientes" value={cab.totalcreditocliente ?? 0} sx={{ width: 200 }} InputProps={{ readOnly: true }} />
                      <TextField autoComplete="off" label="Retiros" value={cab.totalretiros ?? 0} sx={{ width: 200, color: 'warning.main' }} InputProps={{ readOnly: true }} />
                      <TextField autoComplete="off" label="Préstamos" value={cab.totalprestamos ?? 0} sx={{ width: 200, color: 'warning.main' }} InputProps={{ readOnly: true }} />
                    </Box>
                  </>
                )}
              </Paper>
            </Box>
          </Box>
        </SizeSoftXLayout>

        {/* MODALES intactos */}
        <ModalVisorCortes
          openModalVisorCortes={openModalVisorCortes}
          handleCloseModalVisorCortes={() => handleCerrarModalVisorCortes()}
          listaData={listaCortes}
          handleGenerarCorte={(data) => handleAplicarCorte(data)}
        />

        <FrmLoginValidate
          openModal={openModalValidarAcceso}
          tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
          handleComandoEjecucion={handleHabilitarHerramientas}
          hancleCloseModalValidator={() => handleCloseModalLoginValidarAcceso()}
        />

        <FrmLoginValidate
          openModal={openModalValidator}
          tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
          handleComandoEjecucion={handleAplicacionCortes}
          hancleCloseModalValidator={() => handleCloseModalLoginValidatorCortes()}
        />

        <ModalCorteCaja
          openModalVisorCortes={openModalCortes}
          handleCloseModalVisorCortes={() => handleCerrarModalCortes()}
          caja={(listaCortes?.pc ?? "").trim()}
          fechaCorte={listaCortes?.fechaCorte}
          usuario={listaCortes?.usuario}
          handleGenerarCorteCaja={handleGenerarCorteCaja}
        />

        <ModalAperturaCaja
          openModal={openModalAperturaCaja}
          onClose={() => setOpenModalAperturaCaja(false)}
          onSuccess={handleCierreExitosoApertura}
          caja={getCajaValue(cajaSeleccionada)}
        />

        <ModalCierreCaja
          openModal={openModalCierreCaja}
          onClose={() => setOpenModalCierreCaja(false)}
          onSuccess={handleCierreExitosoCaja}
          caja={getCajaValue(cajaSeleccionada)}
          statusCaja={statusCajaAdmin}
          resumenCorte={cab ?? {}}
          usuario={usuarioData?.Usuario}
        />

        <ModalRetiroCapital
            openModal={openModalRetiroCapital}
            onClose={() => setOpenModalRetiroCapital(false)}
            onSuccess={handleCierreExitosoRetiro}
            caja={getCajaValue(cajaSeleccionada)}
            resumenCorte={cab ?? {}}
            usuarioAutorizado={usuarioData?.Usuario}
        />

        <FrmLoginValidate
          openModal={openModalLoginValePorCambio}
          tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
          handleComandoEjecucion={handleConfirmLoginValePorCambio}
          hancleCloseModalValidator={() => setOpenModalLoginValePorCambio(false)}
        />

        <ModalGenerarValePorCambio
          open={openModalValePorCambio}
          onClose={() => setOpenModalValePorCambio(false)}
          onSaved={() => {
            setOpenModalValePorCambio(false);
            refreshStatusCaja();
          }}
          caja={getCajaValue(cajaSeleccionada)}
          usuarioAutoriza={usuarioAutorizaVale}
          usuario={usuarioData?.Usuario}
        />

        <SizeSoftXLoadingProcess
          open={statusWaiting}
          message="Procesando información, por favor espere..."
        />

        <ModalReporte8020
          openModal={openModalReporte8020}
          onClose={() => setOpenModalReporte8020(false)}
        />

        <ModalResumenVentasPeriodo
          openModal={openModalResumenVentasPeriodo}
          onClose={() => setOpenModalResumenVentasPeriodo(false)}
          caja={getCajaValue(cajaSeleccionada)}
        />

        <ModalInventarioExistente
          openModal={openModalInventarioExistente}
          onClose={() => setOpenModalInventarioExistente(false)}
        />

        <ModalReporteEntradasSalidasPeriodo
          openModal={openModalEntradasSalidasPeriodo}
          onClose={() => setOpenModalEntradasSalidasPeriodo(false)}
        />

        <ModalReimpresionCaja
          openModal={openModalReimpresion}
          onClose={() => setOpenModalReimpresion(false)}
          tipo={tipoReimpresion}
          caja={cajaSeleccionada}
        />
      </div>
    </Fragment>
  );
}
